<template>
  <div class="container pt-5 pb-5">

    <div class="row mb-4 d-flex align-items-center mb-5">
      <div class="col">
        <h5 v-for="category in categoryName" :key="category['.key']"> {{ category.name }} </h5>
      </div>
      <div class="col-md-2 d-flex justify-content-end">
        <router-link class="btn btn-primary c-btn" to="/user/files"> Back </router-link>
      </div>
    </div>

    <div class="mt-5" v-for="(subcategory, key) in subcategories" :key="key">
      <h5> {{ subcategory.name }} </h5>
      <hr>

      <docs :category="$route.params.slug" :subcategory="subcategory.slug" />

    </div>

  </div>
</template>

<script>
  import { categories } from '../../firebase'
  import Docs from './Docs'

  export default {
    components: { Docs },
    firestore() {
      return {
        categoryName: categories.where('slug', '==', this.$route.params.slug).orderBy("slug").limit(1),
        subcategories: categories.doc(this.$route.params.slug).collection('subcategories')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/Category.vue